"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function ConsultationTopics() {
  return <section id="topics" className="bg-background pt-0 pb-16 md:pb-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-1">
            <span className="inline-block w-fit bg-primary text-primary-foreground text-sm font-bold px-3 py-1 rounded-sm mb-4">ご相談内容</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">職場のこと、家族のこと、<br />自分自身のこと</h2>
            <Separator className="w-12 h-0.5 bg-primary mb-8" />
            <div className="space-y-6">
              <p className="text-foreground leading-relaxed font-default">当ルームには、職場の人間関係や仕事のストレス、夫婦・パートナーとの関係、お子さんの発達や子育て、自分の性格や生き方についての悩みなど、さまざまなご相談が寄せられます。</p>
              <p className="text-foreground leading-relaxed font-default">「こんなことで相談してよいのだろうか」と迷われる方も少なくありませんが、その迷いも含めてご相談いただいてかまいません。何をどのように話していくかは、お話を伺いながら一緒に考えていきます。</p>
            </div>
            <div className="pt-8">
              <Button asChild variant="outline" size="lg" className="border-primary text-primary-heading hover:bg-primary/10 px-8 rounded-lg">
                <Link to="https://yotsuya-sc-room.com/service/">ご相談内容を見る</Link>
              </Button>
            </div>
          </div>
          <div className="order-2">
            <img src="https://yotsuya-sc-room.com/wp-content/uploads/2026/10/fe228d52ee0af0cccaa284054d31583e.jpg" alt="やわらかい光が差し込む窓辺の椅子とソファ" loading="lazy" className="w-full rounded-lg shadow-lg object-cover object-[30%_center] aspect-[4/3]" />
          </div>
        </div>
      </div>
    </section>;
}